import { FieldWithLabel } from '../../../../components/FieldWithLabel/FieldWithLabel'
import { LeadByIndicator } from '../../../../components/LeadByIndicator'
import Typography from '../../../../components/Typography/Typography'
import { LED_BY_LABEL } from '../../../../components/LeadByIndicator/constants'
import { IconFullName } from '../../../../components/IconFullName/IconFullName'
import { ROLES_NAMES } from '../../../../constants'
import Popup from '../../../../components/Popup/Popup'
import { useCognusRepositoryPopup } from '../../Providers/CognusRepositoryPopupProvider'
import { useCallback, useEffect, useState } from 'react'
import { TOpportunityAnalysisContactPersonsList } from '../types'
import { useDispatch } from 'react-redux'
import { setLoading } from '../../../../redux/store/common/slice'
import { getLedByContactPersonsList } from '../../../Contracts/api'
import './styles.scss'

export const LedByInfoModal = () => {
  const { contactPersonsPopup } = useCognusRepositoryPopup()
  const { actions, state } = contactPersonsPopup
  const { uuid, led_by, contract_category } = state.payload

  const [contactPersons, setContactPersons] = useState<
    TOpportunityAnalysisContactPersonsList[]
  >([])
  const dispatch = useDispatch()

  const getContactPerson = useCallback(
    async (uuid: string) => {
      dispatch(setLoading(true))
      await getLedByContactPersonsList(uuid)
        .then((res) => {
          setContactPersons(res.data.results)
        })
        .finally(() => {
          dispatch(setLoading(false))
        })
    },
    [dispatch]
  )

  useEffect(() => {
    getContactPerson(uuid)
    return () => setContactPersons([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid])

  return (
    <div className="contact-persons-wrapper">
      <Popup
        visible={state.visible}
        onCancel={actions.close}
        title={contract_category}
        width={460}
        footer={null}
      >
        <>
          <FieldWithLabel
            title="Led by"
            className="contact-persons-wrapper__led-by"
          >
            <div className="contact-persons-wrapper__led-by__wrapper">
              <LeadByIndicator value={led_by} />
              <Typography.Body1>{LED_BY_LABEL[led_by]}</Typography.Body1>
            </div>
          </FieldWithLabel>
          <FieldWithLabel
            title="Contact person"
            className="contact-persons-wrapper__contacts mt-24"
          >
            {contactPersons.map((i) => {
              return (
                <IconFullName
                  className="user-form_community"
                  title=""
                  key={i.uuid}
                  firstName={i.first_name}
                  lastName={i.last_name}
                  roleName={ROLES_NAMES[i.role]}
                  src={i?.avatar?.file_preview}
                  uuid={i.uuid}
                />
              )
            })}
          </FieldWithLabel>
        </>
      </Popup>
    </div>
  )
}
